// extracted by mini-css-extract-plugin
module.exports = {"headline":"SelectSquad_headline__39Par","characters":"SelectSquad_characters__1T7iw"};